
export class Track {
  static event(action) {
    const nuxtApp = useNuxtApp();
    nuxtApp.$gtag.event(action);
    console.log(`Event tracked: ${action}`);
  }

  static screenview(screen) {
    const nuxtApp = useNuxtApp();
    nuxtApp.$gtag.screenview(screen);
    console.log(`Screen view tracked: ${screen}`);
  }

};